import { Loading } from 'element-ui'
export default {
  mutations: {
    setLanguage (state, payload) {
      window.localStorage.setItem('fslang', payload)
      setTimeout(function () {
        let loadinginstance = Loading.service({ fullscreen: true, lock: true })
        loadinginstance.close()
      }, 500)
      location.reload()
    },
    setLoading () {
      let loadinginstance = Loading.service({ fullscreen: true, lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      setTimeout(function () {
        loadinginstance.close()
      }, 1000)
    }
  },
  actions: {
    setLanguage ({commit}, payload) {
      commit('setLanguage', payload)
    },
    setLoading ({commit}) {
      commit('setLoading')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/lang/index.js